module.exports = __webpack_public_path__ + "static/media/23.479c0428.svg";